import { AboutComponent } from "../components/About_Component";

export const About = () => {
  return (
    <AboutComponent />
  );
};
